export default {
  'product-recommendations:title': 'Already tried?',
};
